export const FONT_SIZE_OPTIONS = [
  { label: 'Small', value: '12px' },
  { label: 'Normal', value: '14px' },
  { label: 'Large', value: '16px' },
  { label: 'Huge', value: '20px' },
];
